import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import {
  askSubTabList,
  customerServiceTabList,
} from "../../constant/customerServiceTab";
import LSRgH2HeadLine from "./../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSBdBody01 from "./../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import Pagination from "../../components/molecules/pagination";
import { route } from "../../router/route";
import MOContainer from "./../../components/atoms/layout/moContainer";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import SelectBox from "../../components/organisms/SelectBox";
import LSBdCaption01 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption01";
import AskApi from "../../api/ask.api";
import moment from "moment";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import { toast } from "react-toastify";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Empty from "../../components/molecules/empty";
import Loading from "../../components/templates/loading";

const CustomerServiceAskMy = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line
  const location = useLocation();
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    customerServiceTabList[1].title,
  );

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    askSubTabList[1].title,
  );

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    const tokenData = sessionStorage.getItem("token");

    // 비로그인 사용자가 URL 입력으로 접근 시 리다이렉션
    if (!tokenData) {
      navigate(route.login, {
        replace: true,
        state: { path: window.location.href },
      });
      return;
    } else {
      setToken(tokenData);
    }

    getAskList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지네이션 관련 ---------- //
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 1,
  });

  // ---------- 게시물 리스트 가져오기 ---------- //
  const [askList, setAskList] = useState([]);

  const getAskList = async () => {
    setIsLoading(true);
    try {
      const data = {
        page: page || 1,
        size: pagination.size,
        myFlag: "Active",
      };
      const response = (await AskApi.getList(data)).data.data;

      setAskList(response.content);

      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages:
          response.totalPage ||
          Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      console.error(error);
      toast("문의 내역을 불러오지 못했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📢 고객센터
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {customerServiceTabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 1 ? true : false}
                    title={tab.title}
                  />

                  {index === 1 && (
                    <SubTabWrapper>
                      {askSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            if (!token && index === 1) {
                              navigate(route.login);
                              return;
                            }

                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 1 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02>나의 문의 내역</LSRgDisplay02>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 테이블 */}
                <Table>
                  <tbody>
                    {askList.map((item, index) => (
                      <Tr
                        key={index}
                        style={{
                          borderTop: index === 0 && "1px solid #dbdde0",
                        }}
                      >
                        <td style={{ marginRight: 10 }}>
                          <AnswerStatusBox
                            style={{
                              borderColor: item.answerFlag
                                ? "#5050ff"
                                : "#a4a8b1",
                            }}
                          >
                            <LSBdBody01
                              style={{
                                color: item.answerFlag ? "#5050FF" : "#a4a8b1",
                              }}
                            >
                              {item.answerFlag ? "답변완료" : "답변대기"}
                            </LSBdBody01>
                          </AnswerStatusBox>
                        </td>
                        <td
                          style={{
                            marginRight: 110,
                          }}
                        >
                          <LSRgH2HeadLine
                            style={{
                              color: "#101113",
                              width: 488,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate(
                                `${route.customer_service_ask_detail}/${item.id}`,
                                {
                                  state: {
                                    isMy: 1,
                                  },
                                },
                              );
                            }}
                          >
                            {item?.title || ""}
                          </LSRgH2HeadLine>
                        </td>
                        <td
                          style={{
                            width: 145,
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            marginRight: 57,
                          }}
                        >
                          <img
                            style={{
                              width: 18,
                              height: 18,
                              objectFit: "cover",
                            }}
                            src={"/assets/icons/user.png"}
                            alt={"작성자"}
                          />
                          <LSRgBody01
                            style={{
                              width: 121,
                              color: "#898E99",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item?.member?.nickname || ""}
                          </LSRgBody01>
                        </td>
                        <td
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: 88,
                          }}
                        >
                          <LSRgBody01 style={{ color: "#898E99" }}>
                            {moment(item.createdAt).format("YYYY.MM.DD")}
                          </LSRgBody01>
                        </td>
                      </Tr>
                    ))}
                  </tbody>
                </Table>

                {askList.length === 0 && (
                  <Empty title={"등록된 문의내역이 없습니다."} />
                )}

                {askList.length > 0 && pagination.totalCount > 10 && (
                  <Pagination
                    route={route.customer_service_ask_my}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>📢 고객센터</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={customerServiceTabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={askSubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <TableWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine
                style={{
                  marginBottom: 20,
                }}
              >
                나의 문의 내역
              </LSRgH1HeadLine>

              {/* 본문 영역 - 테이블 */}
              <Table $isSmall={isSmall}>
                <tbody>
                  {askList.map((item, index) => (
                    <Tr
                      key={index}
                      $isSmall={isSmall}
                      style={{
                        borderTop: index === 0 && "1px solid #dbdde0",
                      }}
                    >
                      <td
                        style={{
                          display: "flex",
                          width: 315,
                          flexDirection: "column",
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                          }}
                        >
                          <AnswerStatusBox
                            style={{
                              borderColor: item.answerFlag
                                ? "#5050FF"
                                : "#A4A8B1",
                            }}
                          >
                            <LSBdCaption01
                              style={{
                                color: item.answerFlag ? "#5050FF" : "#A4A8B1",
                              }}
                            >
                              {item.answerFlag ? "답변완료" : "답변대기"}
                            </LSBdCaption01>
                          </AnswerStatusBox>
                          <LSRgBody01
                            style={{
                              maxWidth: 247,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              wordBreak: "normal",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              WebkitLineClamp: 2, // 2줄부터 ... 표시
                            }}
                            onClick={() => {
                              navigate(
                                `${route.customer_service_ask_detail}/${item.id}`,
                                {
                                  state: {
                                    isMy: 1,
                                  },
                                },
                              );
                            }}
                          >
                            {item?.title || ""}
                          </LSRgBody01>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            paddingLeft: 68,
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <img
                              style={{
                                width: 14,
                                height: 14,
                                objectFit: "cover",
                              }}
                              src={"/assets/icons/user.png"}
                              alt={"작성자"}
                            />
                            <LSRgBody01
                              style={{
                                width: 86,
                                color: "#898E99",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item?.member?.nickname || ""}
                            </LSRgBody01>
                          </div>
                          <LSRgBody01 style={{ width: 88, color: "#898E99" }}>
                            {moment(item.createdAt).format("YYYY.MM.DD")}
                          </LSRgBody01>
                        </div>
                      </td>
                    </Tr>
                  ))}
                </tbody>
              </Table>

              {askList.length === 0 && (
                <Empty title={"등록된 문의내역이 없습니다."} />
              )}

              <div>
                {askList.length > 0 && (
                  <Pagination
                    style={{
                      marginBottom: 76,
                    }}
                    route={route.customer_service_ask_my}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </div>
            </TableWrapper>
          </ContentContainer>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              width: "100%",
              position: "sticky",
              bottom: 20,
            }}
          >
            <WriteBtnMobile
              onClick={() => {
                let isLogin = sessionStorage.getItem("isLogin");
                if (isLogin === "true") {
                  navigate(route.customer_service_ask_write);
                } else {
                  toast("글쓰기를 위해 로그인을 해주세요.");
                  navigate(`${route.login}`, {
                    state: { path: window.location.href },
                  });
                }
              }}
            >
              <img
                style={{
                  width: 30,
                  height: 30,
                  objectFit: "cover",
                }}
                src={"/assets/icons/pen_white.png"}
                alt="글쓰기"
              />
              <LSRgCaption02 style={{ color: "#fff" }}>글쓰기</LSRgCaption02>
            </WriteBtnMobile>
          </div>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default CustomerServiceAskMy;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  justify-content: ${(props) =>
    props.$isSmall ? "flex-start" : "space-between"};
  gap: ${(props) => (props.$isSmall ? "16px" : "4px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const TableWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 335px;
  height: fit-content;
`;

const Table = styled.table.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  border-spacing: 0px;
  border-collapse: collapse;
`;

const Tr = styled.tr.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "96px" : "64px")};
  border-bottom: 1px solid #dbdde0;
  padding: 16px 10px;
  display: flex;
  align-items: center;
`;

const AnswerStatusBox = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "58px" : "77px")};
  height: ${(props) => (props.$isSmall ? "fit-content" : "32px")};
  padding: ${(props) => (props.$isSmall ? "6px 12px" : "0px")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  border: 1px solid;
`;

const WriteBtnMobile = styled.button.attrs((props) => {})`
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 75px;
  height: 75px;
  background-color: #5050ff;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;
